import gql from 'graphql-tag';

export default gql`
  query users($input: UsersQueryInput) {
    users(input: $input) {
        status
        message
        totalUsers
        totalFilteredUsers
        users {
          uid
          firstName
          lastName
          businessUnit
          emailAddress
          status
          created
          lastUpdated
          lastLogin 
        }      
      }
    }
`;



// WEBPACK FOOTER //
// ./src/app/queries/usersSearch.js